import React from 'react';
import { IconProps } from '.';

const SvgColoredTwoCoins = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <mask
        id='ColoredTwoCoins_svg__a'
        width={19}
        height={12}
        x={5}
        y={11}
        maskUnits='userSpaceOnUse'
        style={{
          maskType: 'alpha',
        }}
      >
        <path
          fill='#FFDC60'
          d='M5.552 14.34c.594-2.264 4.88-3.407 9.744-2.56 4.877.851 8.527 3.388 8.297 5.724.012.008.015.032 0 .103-.052.243-.113.576-.147.656-.02.053-.257 1.283-.259 1.306-.496 2.323-4.77 3.48-9.702 2.617-4.932-.862-8.552-3.355-8.214-5.727 0-.024.147-1.364.15-1.384.005-.251.05-.5.13-.736Z'
        />
      </mask>
      <g mask='url(#ColoredTwoCoins_svg__a)'>
        <path
          fill='url(#ColoredTwoCoins_svg__b)'
          d='M23.446 18.263c-.02.051-.258 1.29-.258 1.306-.496 2.323-4.77 3.48-9.703 2.617-4.932-.862-8.552-3.355-8.214-5.727 0-.021.148-1.364.15-1.384.007-.331.082-.657.22-.958 1.152-1.848 5.15-2.395 9.56-1.629 4.302.752 7.653 2.814 8.224 4.905.067.258.22-.029.168.214-.052.243-.113.576-.147.656Z'
        />
        <path
          fill='#FFE46E'
          d='M23.574 17.663c.416-2.38-3.29-5.013-8.278-5.883-4.988-.87-9.368.354-9.784 2.733-.415 2.38 3.29 5.013 8.279 5.882 4.987.87 9.367-.354 9.783-2.732Z'
        />
        <path
          fill='#F0B363'
          d='M15.053 13.48c3.313.575 5.876 2.116 6.158 3.614a.189.189 0 0 0 0-.034c.284-1.621-2.476-3.459-6.165-4.102-3.69-.642-6.91.15-7.194 1.774-.03.165-.03.335 0 .5.336-1.613 3.537-2.392 7.201-1.752Z'
          style={{
            mixBlendMode: 'multiply',
          }}
        />
        <path
          fill='url(#ColoredTwoCoins_svg__c)'
          d='M14.028 18.828c3.664.638 6.863-.142 7.183-1.74-.281-1.484-2.842-3.025-6.157-3.613-3.664-.64-6.865.139-7.186 1.74.284 1.486 2.848 3.027 6.16 3.613Z'
        />
        <g filter='url(#ColoredTwoCoins_svg__d)' opacity={0.53}>
          <path
            fill='#fff'
            fillOpacity={0.81}
            d='m10.18 14.246.959.932 2.248-.137.762 3.198 5.168-.315-.962-.934-2.23.137-.777-3.196-5.168.315Z'
          />
          <path
            fill='url(#ColoredTwoCoins_svg__e)'
            fillOpacity={0.41}
            d='m10.18 14.246.959.932 2.248-.137.762 3.198 5.168-.315-.962-.934-2.23.137-.777-3.196-5.168.315Z'
          />
        </g>
        <path
          fill='#E3A402'
          fillOpacity={0.6}
          d='M22.943 12.189c-.002-.016.005-2.305.005-2.305-.9-2.109-4.944-3.823-9.906-4.043C7.955 5.62 3.495 6.716 2.414 8.8c-.12.332-.165.682-.132 1.029 0 .022-.005 1.444-.002 1.465-.096 2.523 4.305 4.652 9.994 4.905 5.69.253 10.389-1.517 10.669-4.01Z'
          style={{
            mixBlendMode: 'multiply',
          }}
        />
        <path
          fill='url(#ColoredTwoCoins_svg__f)'
          fillOpacity={0.36}
          d='M22.943 12.189c-.002-.016.005-2.305.005-2.305-.9-2.109-4.944-3.823-9.906-4.043C7.955 5.62 3.495 6.716 2.414 8.8c-.12.332-.165.682-.132 1.029 0 .022-.005 1.444-.002 1.465-.096 2.523 4.305 4.652 9.994 4.905 5.69.253 10.389-1.517 10.669-4.01Z'
        />
      </g>
      <path
        fill='url(#ColoredTwoCoins_svg__g)'
        d='M21.163 9.929a50.461 50.461 0 0 0-.294 1.483c-.563 2.638-5.416 3.951-11.017 2.972-5.6-.979-9.711-3.81-9.327-6.504 0-.023.167-1.548.17-1.571.008-.376.093-.746.25-1.088 1.308-2.098 5.847-2.72 10.855-1.85 4.886.854 8.691 3.196 9.34 5.57.076.293.249-.032.19.243-.059.276-.129.654-.167.745Z'
      />
      <path
        fill='#FFE46E'
        d='M21.308 9.247c.472-2.701-3.737-5.692-9.4-6.679C6.244 1.58 1.27 2.97.798 5.671c-.472 2.702 3.737 5.692 9.4 6.68 5.664.987 10.638-.402 11.11-3.104Z'
      />
      <path
        fill='url(#ColoredTwoCoins_svg__h)'
        fillOpacity={0.41}
        d='M21.308 9.247c.472-2.701-3.737-5.692-9.4-6.679C6.244 1.58 1.27 2.97.798 5.671c-.472 2.702 3.737 5.692 9.4 6.68 5.664.987 10.638-.402 11.11-3.104Z'
      />
      <path
        fill='#F0B363'
        d='M11.633 4.497c3.761.654 6.672 2.404 6.992 4.104a.242.242 0 0 0 0-.038c.322-1.84-2.811-3.928-7-4.658-4.19-.73-7.847.17-8.17 2.014a1.61 1.61 0 0 0 0 .569c.382-1.832 4.017-2.718 8.178-1.99Z'
        style={{
          mixBlendMode: 'multiply',
        }}
      />
      <path
        fill='url(#ColoredTwoCoins_svg__i)'
        fillOpacity={0.16}
        d='M11.633 4.497c3.761.654 6.672 2.404 6.992 4.104a.242.242 0 0 0 0-.038c.322-1.84-2.811-3.928-7-4.658-4.19-.73-7.847.17-8.17 2.014a1.61 1.61 0 0 0 0 .569c.382-1.832 4.017-2.718 8.178-1.99Z'
      />
      <path
        fill='url(#ColoredTwoCoins_svg__j)'
        d='M10.469 10.571c4.16.724 7.792-.161 8.156-1.976-.32-1.685-3.227-3.435-6.992-4.103-4.16-.727-7.795.158-8.16 1.975.324 1.689 3.234 3.439 6.996 4.104Z'
      />
      <g filter='url(#ColoredTwoCoins_svg__k)'>
        <path
          fill='#fff'
          fillOpacity={0.81}
          d='m6.1 5.368 1.088 1.058 2.553-.155.865 3.631 5.868-.357-1.091-1.061-2.532.155-.884-3.629-5.868.358Z'
        />
        <path
          fill='url(#ColoredTwoCoins_svg__l)'
          fillOpacity={0.41}
          d='m6.1 5.368 1.088 1.058 2.553-.155.865 3.631 5.868-.357-1.091-1.061-2.532.155-.884-3.629-5.868.358Z'
        />
      </g>
      <defs>
        <linearGradient
          id='ColoredTwoCoins_svg__b'
          x1={5.699}
          x2={22.915}
          y1={16.049}
          y2={23.529}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FFC123' />
          <stop offset={0.276} stopColor='#FFD361' />
          <stop offset={0.823} stopColor='#FFB906' />
        </linearGradient>
        <linearGradient
          id='ColoredTwoCoins_svg__c'
          x1={14.54}
          x2={14.54}
          y1={13.251}
          y2={19.051}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FFB52B' />
          <stop offset={1} stopColor='#FDD06D' />
        </linearGradient>
        <linearGradient
          id='ColoredTwoCoins_svg__e'
          x1={12.735}
          x2={15.133}
          y1={15.155}
          y2={18.625}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FFFFAD' stopOpacity={0} />
          <stop offset={0.314} stopColor='#FFFF90' />
          <stop offset={1} stopColor='#FFFFAD' stopOpacity={0} />
        </linearGradient>
        <linearGradient
          id='ColoredTwoCoins_svg__f'
          x1={16.931}
          x2={18.159}
          y1={13.57}
          y2={15.525}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#7E0101' />
          <stop offset={1} stopColor='#7E0101' stopOpacity={0} />
        </linearGradient>
        <linearGradient
          id='ColoredTwoCoins_svg__g'
          x1={1.011}
          x2={20.56}
          y1={7.415}
          y2={15.909}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FFC123' />
          <stop offset={0.276} stopColor='#FFD361' />
          <stop offset={0.823} stopColor='#FFB906' />
        </linearGradient>
        <linearGradient
          id='ColoredTwoCoins_svg__h'
          x1={5.25}
          x2={9.75}
          y1={4.15}
          y2={9.4}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FFFFAD' stopOpacity={0} />
          <stop offset={0.314} stopColor='#FFFF90' />
          <stop offset={1} stopColor='#FFFFAD' stopOpacity={0} />
        </linearGradient>
        <linearGradient
          id='ColoredTwoCoins_svg__i'
          x1={9.75}
          x2={13.289}
          y1={3.4}
          y2={8.771}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#7E0101' />
          <stop offset={1} stopColor='#7E0101' stopOpacity={0} />
        </linearGradient>
        <linearGradient
          id='ColoredTwoCoins_svg__j'
          x1={11.05}
          x2={11.05}
          y1={4.238}
          y2={10.824}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FFB52B' />
          <stop offset={1} stopColor='#FDD06D' />
        </linearGradient>
        <linearGradient
          id='ColoredTwoCoins_svg__l'
          x1={9}
          x2={11.723}
          y1={6.4}
          y2={10.341}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FFFFAD' stopOpacity={0} />
          <stop offset={0.314} stopColor='#FFFF90' />
          <stop offset={1} stopColor='#FFFFAD' stopOpacity={0} />
        </linearGradient>
        <filter
          id='ColoredTwoCoins_svg__d'
          width={9.136}
          height={4.308}
          x={10.18}
          y={13.931}
          colorInterpolationFilters='sRGB'
          filterUnits='userSpaceOnUse'
        >
          <feFlood floodOpacity={0} result='BackgroundImageFix' />
          <feBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feColorMatrix in='SourceAlpha' result='hardAlpha' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' />
          <feOffset dx={-0.1} dy={0.1} />
          <feComposite in2='hardAlpha' k2={-1} k3={1} operator='arithmetic' />
          <feColorMatrix values='0 0 0 0 0.870588 0 0 0 0 0.529412 0 0 0 0 0.145098 0 0 0 0.6 0' />
          <feBlend in2='shape' mode='darken' result='effect1_innerShadow_51908_3871' />
        </filter>
        <filter
          id='ColoredTwoCoins_svg__k'
          width={10.375}
          height={4.892}
          x={6.099}
          y={5.01}
          colorInterpolationFilters='sRGB'
          filterUnits='userSpaceOnUse'
        >
          <feFlood floodOpacity={0} result='BackgroundImageFix' />
          <feBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feColorMatrix in='SourceAlpha' result='hardAlpha' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' />
          <feOffset dx={-0.1} dy={0.1} />
          <feComposite in2='hardAlpha' k2={-1} k3={1} operator='arithmetic' />
          <feColorMatrix values='0 0 0 0 0.870588 0 0 0 0 0.529412 0 0 0 0 0.145098 0 0 0 0.6 0' />
          <feBlend in2='shape' mode='darken' result='effect1_innerShadow_51908_3871' />
        </filter>
      </defs>
    </svg>
  );
};

export default SvgColoredTwoCoins;
